import { ANALYTICS_ORIGIN_KEY } from '../constants/localStorage';
import { getLocalStorageValue } from './localStorage';

export function getAnalyticsOrigin() {
  return getLocalStorageValue(ANALYTICS_ORIGIN_KEY) || {};
}
